import {
  ADMIN_GROUP_ALL,
  USER_TYPE_ADMIN,
  USER_TYPE_STANDARD,
  STANDARD_GROUP,
  INTERNAL_TEAMS,
} from '../constants/AppConstants';

class AuthUtil {
  static isAdminUser(authData) {
    const groups = authData?.groups ?? [];
    const invitableGroups = authData?.invitable_groups ?? [];
    return ADMIN_GROUP_ALL.some((item) => groups.includes(item))
    && invitableGroups.length > 0;
  }

  static isStdUser(authData) {
    const groups = authData?.groups ?? [];
    const invitableGroups = authData?.invitable_groups ?? [];

    const isNotAdmin = !this.isAdminUser(authData);
    const isStdUser = STANDARD_GROUP.some((item) => groups.includes(item));

    return isNotAdmin && isStdUser && invitableGroups.length === 0;
  }

  static isLegacyUser(authData, userData, tokenData) {
    return (
      !this.isAdminUser(authData)
      && !this.isStdUser(authData)
      && [USER_TYPE_STANDARD, USER_TYPE_ADMIN].includes(userData?.userType?.name)
      && INTERNAL_TEAMS.includes(userData?.group?.groupType?.name)
      && tokenData?.internal === true
    );
  }

  static isValidUser(authData, userData, tokenData) {
    return this.isAdminUser(authData) || this.isStdUser(authData) || this.isLegacyUser(authData, userData, tokenData);
  }
}

export default AuthUtil;
